/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".social-item[_ngcontent-%COMP%]{width:50px;height:100%;display:flex;flex-direction:row;justify-content:center;align-items:center}"];
export { styles as styles };
